module.exports = whenSyncd = (callback) ->
    if @syncd
        callback()
    else
        @once 'sync', callback
